export const artistsPage = {
    'artists.card.image.title': 'Художник - {shortId} | Найди больше интересных художников для тебя на R.Toys',
    'artists.page.title': 'Художники',
}
